import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import Popup from '../Common/Popup';
import Constants from '../../Constants';
import { FaInfoCircle } from 'react-icons/fa';
import { Tooltip } from 'antd';
import DefinitionModal from '../DefinitionModal';

/**
 * The `InvestorTypeFilter` function is a React component that renders a dropdown menu for selecting an
 * investor type.
 * @returns a JSX element.
 */
function InvestorTypeFilter({ InvestorTypeOptions, setInvestorTypeOptions, customPathname, label = "Investor Type", isPopupOpen, setIsPopupOpen }) {
    const { InvestorType, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.investorType?.map(value => value.id) ?? [];
        setInvestorTypeOptions(InvestorType?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.id) })))
    }, [InvestorType, customPathname, refineSearchFilters, setInvestorTypeOptions])

    const handleInvestorTypeChange = (e) => {
        const value = e.target.value
        setInvestorTypeOptions(InvestorTypeOptions?.map(type => ({ ...type, isChecked: value === "" ? false : type.id === value })))
    };

    const selected = InvestorTypeOptions?.filter(option => option.isChecked)?.at(0)

    const [showDefModal, setShowDefModal] = useState(false);
    
    const openModal = (e) => {
        e.stopPropagation(); // Prevent button click from toggling popup
        setShowDefModal(true);
    }
    
    const closeModal = () => {
        setShowDefModal(false);
    }

    // const checkTrue = InvestorTypeOptions?.some(t => t.isChecked);
    // console.log(checkTrue, "check true")

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2 flex items-center gap-2">
                    {label}
                    <Tooltip title='Definitions'>
                        <FaInfoCircle 
                            size={12} 
                            color="grey" 
                            className="cursor-pointer" 
                            onClick={openModal}
                        />
                    </Tooltip>
                    {InvestorTypeOptions && InvestorTypeOptions.length > 0 && (
                        <span className="opacity-60 ml-2 text-xs text-ellipsis">
                            e.g. {InvestorTypeOptions
                                .slice(0,2)
                                .map(item => item.name)
                                .join(', ')
                            }
                        </span>
                    )}
                </span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected?.name && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto space-y-2">
                                <label className="flex items-center space-x-2 pt-1 hover:bg-gray-50 rounded cursor-pointer">
                                    <input
                                        type="radio"
                                        name="investorType"
                                        value=""
                                        checked={!selected}
                                        onChange={handleInvestorTypeChange}
                                        className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                    />
                                    <span className="text-[13px] text-black font-semibold">All</span>
                                </label>
                                <div className='grid grid-cols-2'>
                                {InvestorTypeOptions && InvestorTypeOptions.length > 0 ? (
                                    InvestorTypeOptions
                                        .map((investorType, index) => (
                                            <label key={investorType.id || index} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer py-2">
                                                <input
                                                    type="radio"
                                                    name="investorType"
                                                    value={investorType.id}
                                                    checked={selected?.id === investorType.id}
                                                    onChange={handleInvestorTypeChange}
                                                    className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                                />
                                                <span className="text-[13px] font-semibold">{investorType.name}</span>
                                            </label>
                                        ))
                                    ) : (
                                        <div className="text-sm text-gray-500 p-2">No results found!</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
            {showDefModal && <DefinitionModal label={label} definitionInfo={Constants.investorType} onClose={closeModal}/>}
        </div>
    )
}

export default InvestorTypeFilter